import React from "react";
import "./ReactLoaderInfinite.css";

const ReactLoaderInfinite = () => {
  return (
    <div className="loader__React__Loader__infinite">
      <svg
        className="svg__React__Loader__infinite"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 187.3 93.7"
        height="300px"
        width="400px"
      >
        <path
          d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
          className="outline__React__Loader__infinite"
        ></path>
        <path
          d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
          className="outline-bg__React__Loader__infinite"
        ></path>
      </svg>
    </div>
  );
};

export default ReactLoaderInfinite;
